module.exports = __webpack_public_path__ + "img/imageCardTwo.4a294a01.png";